function setupCookieBanner(consentCallback) {
    const cookieName = 'baraud-consent';
    const cookieValue = 'true';
    const bannerText = 'This website uses cookies to help us enhance your browsing experience. By using this website you consent to our use of these cookies. To find out more about how we use cookies and how to manage them, please see our ';
    const bannerTextMiddle = ' and our ';
    const bannerTextEnd = '.';
    const cookieExists = document.cookie.split(';').filter((item) => { // check if this particular cookie is not in the list of cookies
        return item.trim().indexOf(cookieName+'=') == 0
    }).length > 0

    if (!cookieExists) {
        // build the banner
        let banner = document.createElement('div');
        banner.style.position = 'fixed';
        banner.style.bottom = '0';
        banner.style.left = '0';
        banner.style.right = '0';
        banner.style.padding = '20px';
        banner.style.fontFamily = 'Helvetica,Arial,FreeSans,sans-serif';
        banner.style.background = 'white';
        banner.style.zIndex = '9999';
        banner.style.boxShadow = '5px -4px 17px rgba(0,0,0,0.19), 63px 6px 6px rgba(0,0,0,0.23)';
        let textContainer = document.createElement('div');
        textContainer.style.maxWidth = '900px';
        textContainer.style.margin = '0 auto';

        let privacyLink = document.createElement('a');
        let termsLink = document.createElement('a');
        privacyLink.style.color = '#ff6a00';
        termsLink.style.color = '#10465e';
        privacyLink.setAttribute('href', 'https://www.baraud.com/privacy-policy/privacy-policy');
        termsLink.setAttribute('href', '/terms-conditions');
        privacyLink.style.textDecoration = 'underline';
        termsLink.style.textDecoration = 'underline';
        privacyLink.innerHTML = 'Privacy Policy';
        // termsLink.innerHTML = 'Terms & Conditions';

        let textMiddle = document.createElement('span');
        // textMiddle.innerHTML = bannerTextMiddle;

        let textEnd = document.createElement('span');
        textEnd.innerHTML = bannerTextEnd;

        let text = document.createElement('p');
        text.style.display = 'inline';
        text.style.color = 'black';
        text.style.fontSize = '14px';
        text.style.lineHeight = '1.5';
        text.innerHTML = bannerText;

        let button = document.createElement('button');
        button.style.marginLeft = '10px';
        button.style.color = 'white';
        button.style.backgroundColor = '#ff6a00';
        button.style.borderRadius = '180px';
        button.style.padding = '4px 15px';
        button.style.cursor = 'pointer';
        button.innerHTML = 'Continue';
        // show the banner
        text.appendChild(privacyLink);
        text.appendChild(textMiddle);
        text.appendChild(termsLink);
        text.appendChild(textEnd);
        textContainer.appendChild(text);
        textContainer.appendChild(button);
        banner.appendChild(textContainer);
        document.body.appendChild(banner);

        // append the onclick listener to 'continue'
        button.addEventListener('click', () => {
            let expDate = new Date();
            expDate.setMonth(expDate.getMonth() + 6);

            // store cookie
            document.cookie = cookieName + '=' + cookieValue.toString() + '; expires=' + expDate.toUTCString();
            // remove banner
            banner.parentNode.removeChild(banner);

            if (typeof consentCallback !== 'undefined') {
                consentCallback();
            }
        });
    } else {
        if (typeof consentCallback !== 'undefined') {
            consentCallback();
        }
    }
}

setupCookieBanner(() => {
    window.yett.unblock();
});